import React, { useEffect, useState } from "react";
import {
    useDeleteSurveyByIdMutation,
    useGetSurveysQuery,
} from "../../store/api/formbricks/survey";
import { Button, Empty, message, Space } from "antd";
import { useGetProjectsQuery } from "../../store/api/lumi/projects";
import { useNavigate } from "react-router-dom";
import { openSurveyPreview } from "../../utils/surveys";
import { DeleteOutlined } from "@ant-design/icons";
import { Pagination } from "antd";
import { SurveysActionsComponent } from "./SurveysActionsComponent";
import classes from "./SurveysList.module.css";
import _ from "lodash";

const SurveysList = () => {
    const [workspace, setWorkspace] = useState("private");
    const [searchQuery, setSearchQuery] = useState("");
    const [messageApi, contextHolder] = message.useMessage();
    const [sortBy, setSorting] = useState("createdAt desc");

    const navigate = useNavigate();
    const { data: surveys, isFetching: isSurveysFetching } = useGetSurveysQuery(
        { publicity: workspace }
    );
    const { data: projects, isFetching: isProjectsFetching } =
        useGetProjectsQuery();
    const [deleteSurvey, { isLoading: isDeleteSurveyLoading }] =
        useDeleteSurveyByIdMutation();

    const openPreviewHandler = (id) => {
        openSurveyPreview(id);
    };

    const navigateToSurveyDashboard = (id) => {
        navigate(`${id}/dashboard`);
    };

    const findProjectById = (id) => {
        return projects?.find((project) => project.project_id === id);
    };

    const deleteSurveyHandler = (id) => {
        deleteSurvey(id).unwrap();
    };

    const pageSize = 5;
    const [page, setPage] = useState(1);

    let filteredSurveys = _.chain(surveys)
        .filter(
            (project) =>
                project.name &&
                project.name.toLowerCase().includes(searchQuery.toLowerCase())
        )
        .sortBy(sortBy.replace(" desc", ""))
        .value();
    if (sortBy.includes("desc")) {
        filteredSurveys = filteredSurveys.reverse();
    }

    const paginatedSurveys = filteredSurveys?.slice(
        (page - 1) * pageSize,
        (page - 1) * pageSize + pageSize
    );

    const changePageHandler = (newPage) => {
        setPage(newPage);
    };

    const handleWorkspaceChange = (value) => {
        setWorkspace(value);
    };

    useEffect(() => {
        if (isSurveysFetching || isDeleteSurveyLoading) {
            messageApi.open({
                type: "loading",
                content: "Loading surveys...",
                duration: 0,
            });
        } else {
            messageApi.destroy();
        }
    }, [isDeleteSurveyLoading, isSurveysFetching]);

    return (
        <>
            {contextHolder}
            <SurveysActionsComponent
                currentWorkspace={workspace}
                handleWorkSpaceChange={handleWorkspaceChange}
                searchQuery={searchQuery}
                setSortBy={setSorting}
                sortBy={sortBy}
                setSearchQuery={setSearchQuery}
            />
            <div className="container surveys-list-container">
                <div className="projects-content">
                    {paginatedSurveys && paginatedSurveys.length > 0 ? (
                        <>
                            {paginatedSurveys?.map((surveyItem) => (
                                <div
                                    className={classes.survey_card}
                                    key={surveyItem.id}
                                >
                                    <div className="project-card-header">
                                        <h3>
                                            {surveyItem.name.split("---")[0] ||
                                                "No name provided"}
                                        </h3>
                                    </div>
                                    <Space>
                                        <Button
                                            className="project-list button get-data"
                                            onClick={openPreviewHandler.bind(
                                                null,
                                                surveyItem.id
                                            )}
                                            size="large"
                                        >
                                            Preview
                                        </Button>
                                        <Button
                                            className="project-list button"
                                            type="primary"
                                            size="large"
                                            onClick={navigateToSurveyDashboard.bind(
                                                null,
                                                surveyItem.id
                                            )}
                                        >
                                            Open
                                        </Button>
                                        <Button
                                            type="primary"
                                            onClick={() =>
                                                deleteSurveyHandler(
                                                    surveyItem.id
                                                )
                                            }
                                            danger
                                            icon={<DeleteOutlined />}
                                        />
                                    </Space>
                                </div>
                            ))}
                            <Pagination
                                pageSize={pageSize}
                                current={page}
                                onChange={changePageHandler}
                                total={filteredSurveys?.length}
                                style={{ marginBottom: "20px" }}
                            />
                        </>
                    ) : (
                        <Empty />
                    )}
                </div>
            </div>
        </>
    );
};

export default SurveysList;
